MembershipsController.$inject = ['$rootScope', 'MembershipService', '$stateParams', 'angularGridInstance', 'AppService', '$timeout', '$state']

export default function MembershipsController($rootScope, MembershipService, $stateParams, angularGridInstance, AppService, $timeout, $state) {
  var vm = this

  function getPaymentById(membership) {
    var payment = membership.activities.find(activity => activity.activityType.type === 'Payment')
    if (payment) AppService.getPaymentById(payment.objectId).then(res => {
      membership.paymentMostRecent = res.data

      var now = new Date()
      var startDateUtc = new Date(membership.startDateUtc)
      var endDateUtc = membership.recurrencePattern.pattern === 'Every day' ? new Date(startDateUtc.setUTCDate(startDateUtc.getUTCDate() + 1)) : membership.recurrencePattern.pattern === 'Every week' ? new Date(startDateUtc.setUTCDate(startDateUtc.getUTCDate() + 7)) : membership.recurrencePattern.pattern === 'Every two weeks' ? new Date(startDateUtc.setDate(startDateUtc.getDate() + 14)) : membership.recurrencePattern.pattern === 'Every month' ? new Date(startDateUtc.setUTCMonth(startDateUtc.getUTCMonth() + 1)) : new Date(startDateUtc.setUTCYear(startDateUtc.getUTCYear() + 1))
      if (now > endDateUtc) membership.isExpired = true
    })
  }

  $rootScope.$watch('profile', profile => {
    if (profile !== undefined) {
      MembershipService.getMemberships().then(res => {
        vm.memberships = res.data

        vm.memberships.forEach(membership => getPaymentById(membership) ? membership.activities.length > 0 : null)
      })
      vm.settings = profile.settings.components.find(component => component.name === 'memberships')
    }
  })

  vm.currentPage = $stateParams.page
  vm.pageSize = 24
  vm.maxSize = 5

  vm.toggleManageMembershipTypes = function() {
    vm.manageMembershipTypes = !vm.manageMembershipTypes
  }
  vm.setView = function() {
    vm.settings.view = vm.settings.view === 'grid' ? 'list' : 'grid', angularGridInstance.grid.refresh()
    AppService.patchSettings('components', $rootScope.profile.settings.components, $rootScope.profile.settings.id)
  }
  vm.setSortBy = function(property) {
    var copy = vm.memberships
    vm.memberships = null
    function compare(a, b) {
      let comparison = 0
      if (a[property] > b[property]) {
        comparison = vm.sortChanged ? -1 : 1
      } else if (a[property] < b[property]) {
        comparison = vm.sortChanged ? 1 : -1
      }
      return comparison
    }
    function compareNested(a, b) {
      let comparison = 0
      while (comparison < property.length) { a = a[property[comparison]]; b = b[property[comparison]]; comparison++; }
      if (a > b) {
        comparison = vm.sortChanged ? -1 : 1
      } else if (a < b) {
        comparison = vm.sortChanged ? 1 : -1
      }
      return comparison
    }
    if (property.includes('.')) {
      property = property.split('.')
      copy.sort(compareNested)
    } else {
      copy.sort(compare)
    }
    vm.sortChanged = !vm.sortChanged
    $timeout(function() {
      vm.memberships = copy
    }, 100)
  }
  vm.toggleManageSettings = function() {
    vm.manageSettings = !vm.manageSettings
  }
  vm.numberOfPages = function() {
    return parseInt(vm.memberships.length / vm.pageSize)
  }
  vm.pageChanged = function(currentPage) {
    $state.go('.', { page: currentPage }, { notify: false })
  }
}